import {isEmpty} from 'lodash';

export default {
  basicProfileDataState(state) {
    return state.basicProfileData;
  },
  basicProfileDataErrorsState(state) {
    return state.basicProfileDataErrors;
  },
  basicProfileDataHasErrorsState(state) {
    for (let key in state.basicProfileDataErrors) {
      if (state.basicProfileDataErrors[key]) {
        return true;
      }
    }

    return false;
  },
  profileOptionsLoadingState(state) {
    return state.profileOptionsLoading;
  },
  profileOptionsState(state) {
    return state.profileOptions;
  },
  profileCitiesOptionsState(state) {
    let topCities = ['Shanghai', 'Beijing', 'Hong Kong', 'Singapore', 'Shenzhen', 'Guangzhou', 'Suzhou'];
    let top = [];
    let other = [];

    if (isEmpty(state.profileOptions) || isEmpty(state.profileOptions.cities)) {
      return [];
    }

    for (let city of state.profileOptions.cities) {
      topCities.includes(city.name) ? top.push(city) : other.push(city);
    }

    top = top.sort((a, b) => {
      return topCities.indexOf(a.name) - topCities.indexOf(b.name);
    });

    return top.length ? [...top, {isSeparator: true}, ...other] : [...other];
  },
  jobTitlesOptionsState(state) {
    return state.jobTitlesOptions;
  },
  jobTitlesOptionsLoadingState(state) {
    return state.jobTitlesOptionsLoading;
  }
};
